import React from 'react';
import { useDateTimeHelpers } from './hooks/useDateTimeHelpers';
import { useReservationForm } from './hooks/useReservationForm';

// Sub-components
import {
    DateRangePicker,
    NotesField,
    ResourceInfo,
    ReservationFormActions,
    ErrorDisplay
} from './components';
import DynamicBorrowingFields from './components/DynamicBorrowingFields';

import './ReservationForm.scss';

const ReservationForm = ({
    data,
    reservation, // Legacy prop - now points to borrowing data
    onSubmit,
    onCancel,
    isEditing = false,
    loading: externalLoading = false,
    resource = null
}) => {
    const {
        currentLanguage,
        gregorian,
        getDateLocale,
        getDateFormat
    } = useDateTimeHelpers();

    // Support both `data` (from common components) and `reservation` (legacy)
    const modelData = data || reservation;

    const {
        formData,
        reservedFromDate,
        reservedUntilDate,
        internalLoading,
        error,
        handleReservedFromDateChange,
        handleReservedUntilDateChange,
        handleInputChange,
        handleDynamicFieldsChange,
        handleSubmit
    } = useReservationForm(modelData, resource);

    const loading = externalLoading || internalLoading;

    return (
        <form onSubmit={(e) => handleSubmit(e, onSubmit)} className="reservation-form">
            <ErrorDisplay error={error} />

            <ResourceInfo resource={resource} context="reservation" />

            <DateRangePicker
                fromDate={reservedFromDate}
                untilDate={reservedUntilDate}
                onFromDateChange={handleReservedFromDateChange}
                onUntilDateChange={handleReservedUntilDateChange}
                dateFormat={getDateFormat()}
                calendar={gregorian}
                locale={getDateLocale()}
                disabled={loading}
                currentLanguage={currentLanguage}
                fromLabel="reservation.reserved_from"
                untilLabel="reservation.reserved_until"
                fromPlaceholder="reservation.select_from_date"
                untilPlaceholder="reservation.select_until_date"
            />

            <NotesField
                value={formData.reservation_notes}
                onChange={handleInputChange}
                disabled={loading}
                name="reservation_notes"
                label="reservation.notes"
                placeholder="reservation.notes_placeholder"
                rows={3}
            />

            {/* Dynamic borrowing fields for reservation context */}
            {resource && resource.category_id && (
                <DynamicBorrowingFields
                    categoryId={resource.category_id}
                    context="reservation"
                    existingFields={formData.dynamic_fields}
                    onChange={handleDynamicFieldsChange}
                    disabled={loading}
                />
            )}

            <ReservationFormActions
                onCancel={onCancel}
                loading={loading}
                isEditing={isEditing}
            />
        </form>
    );
};

export default ReservationForm;
